// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2IcH3","infoBtn":"quickbooks_infoBtn__3jIrO","formBox":"quickbooks_formBox__QBI2N","formFooter":"quickbooks_formFooter__3K0Jx"};